var _path, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyDestinations = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 42,
    viewBox: "0 0 101 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C1.34315 1 0 2.34315 0 4V39C0 40.6569 1.34315 42 3 42H21C22.6569 42 24 40.6569 24 39V4C24 2.34315 22.6569 1 21 1H3ZM21 7H3V36H21V7Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9998 18.9333V16.5008C46.9998 16.0769 47.4942 15.8453 47.8199 16.1167L52.5388 20.0491C52.7787 20.249 52.7787 20.6174 52.5388 20.8173L47.8199 24.7499C47.4942 25.0212 46.9998 24.7897 46.9998 24.3657V21.9333H41.4998C40.6713 21.9333 39.9998 21.2617 39.9998 20.4333C39.9998 19.6048 40.6713 18.9333 41.4998 18.9333H46.9998Z",
    fill: "#BDBDBD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 20.5,
    r: 1.5,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 20.5,
    r: 1.5,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 21,
    r: 20,
    fill: "white",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 11C74.48 11 70 15.48 70 21C70 26.52 74.48 31 80 31C85.52 31 90 26.52 90 21C90 15.48 85.52 11 80 11ZM81 28H79V26H81V28ZM83.07 20.25L82.17 21.17C81.67 21.68 81.31 22.14 81.13 22.86C81.05 23.18 81 23.54 81 24H79V23.5C79 23.04 79.08 22.6 79.22 22.19C79.42 21.61 79.75 21.09 80.17 20.67L81.41 19.41C81.87 18.97 82.09 18.31 81.96 17.61C81.83 16.89 81.27 16.28 80.57 16.08C79.46 15.77 78.43 16.4 78.1 17.35C77.98 17.72 77.67 18 77.28 18H76.98C76.4 18 76 17.44 76.16 16.88C76.59 15.41 77.84 14.29 79.39 14.05C80.91 13.81 82.36 14.6 83.26 15.85C84.44 17.48 84.09 19.23 83.07 20.25Z",
    fill: "#BDBDBD"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyDestinations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyDestinations.b2ce07a1.svg";
export { ForwardRef as ReactComponent };